export default __webpack_public_path__ + "static/media/regulatory--text--g2.12b5de42.png";